import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-index-funciones',
  templateUrl: './index-funciones.component.html',
  styleUrls: ['./index-funciones.component.css']
})
export class IndexFuncionesComponent implements OnInit {

  promocion = ''

  functions = []

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));
    this.functions = [
      {
        name: 'Capitales',
        route: `/CredisystemSite/portafolio/promociones/funciones/capitales/${this.promocion}`
      },
      {
        name: 'Plazos',
        route: '/CredisystemSite/portafolio/promociones/funciones/plazos/' + this.promocion
      },
      {
        name: 'Ciclos',
        route: '/CredisystemSite/portafolio/promociones/funciones/ciclos/' + this.promocion
      },
      {
        name: 'Contabilidad',
        route: '/CredisystemSite/portafolio/promociones/funciones/contabilidad/' + this.promocion
      },
      {
        name: 'Definiciones',
        route: '/CredisystemSite/portafolio/promociones/funciones/definiciones/' + this.promocion
      },
      {
        name: 'Estatus Legal',
        route: '/CredisystemSite/portafolio/promociones/funciones/estatus-legal/' + this.promocion
      },
      {
        name: 'Simulador',
        route: '/CredisystemSite/portafolio/promociones/funciones/simulador/' + this.promocion
      },
    ]    
  }

}
